/**
 * Event Bus für Broadcasts
 * folgende Werte können über den Eventbus gesetzt werden
 * set-language
 * set-user
 * set-all-tabs-valid
 */
import Vue from 'vue';
export const EventBus = new Vue();
